import fetch from 'cross-fetch';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { API_GRAPHQL_URL } from '../constants/env';
const httpLink = createHttpLink({
    uri: API_GRAPHQL_URL,
    fetch,
});
const authLink = setContext((request, { headers /*, ...context*/ }) => {
    // get the authentication token from local storage if it exists
    const token = window.localStorage?.getItem('token');
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            'x-auth-token': token,
        },
    };
});
export default new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
});
